var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavBarCoffee',{attrs:{"background-image":_vm.config.backgroundImage,"background-color":_vm.config.backgroundColor,"slide-transition":false,"title-is-center":true}})}
var staticRenderFns = []

export { render, staticRenderFns }